import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userId: "", // 已登记的用户id
    checkCommunity: {}, // 确认的社区
    checkHousing: {}, // 确认的小区
    baseInfo: {}, // 基本信息
    pictureInfo: "", // 上传的照片
    pictureFile: "", // 上传的照片文件
  },
  getters: {
    userId(state) {
      return state.userId;
    }, // 已登记的用户id
    checkCommunity(state) {
      return state.checkCommunity;
    }, // 确认的社区
    checkHousing(state) {
      return state.checkHousing;
    }, // 确认的小区
    baseInfo(state) {
      return state.baseInfo;
    }, // 基本信息
    pictureInfo(state) {
      return state.pictureInfo;
    }, // 上传的照片
    pictureFile(state) {
      return state.pictureFile;
    }, // 上传的照片文件
  },
  mutations: {
    setUserId(state, newData) {
      state.userId = newData;
    }, // 已登记的用户id
    setCheckCommunity(state, newData) {
      state.checkCommunity = newData;
    }, // 修改确认的社区
    setCheckHousing(state, newData) {
      state.checkHousing = newData;
    }, // 修改确认的小区
    setBaseInfo(state, newData) {
      state.baseInfo = newData;
    }, // 修改基本信息
    setPictureInfo(state, newData) {
      state.pictureInfo = newData;
    }, // 修改上传的照片
    setPictureFile(state, newData) {
      state.pictureFile = newData;
    }, // 修改上传的照片文件
  },
  actions: {},
  modules: {},
});
